module.exports = __webpack_public_path__ + "static/media/p1.3af8ef91.png";